export default __webpack_public_path__ + "static/media/phone-green.76b1f03a.svg";